import {IState, IStateParamsService} from 'angular-ui-router';
import {RouterHelper} from '../dvbModules/router/route-helper-provider';
import TSAnlaufstelle from '../models/TSAnlaufstelle';
import RoleUtilService from '../core/service/RoleUtilService';
import AnlaufstelleRS from '../core/service/AnlaufstelleRS.rest';
import AuthServiceRS from '../authentication/service/AuthServiceRS.rest';
import TSAdresse from '../models/TSAdresse';
import TSPasswordData from '../models/TSPasswordData';
import BenutzerRS from '../core/service/BenutzerRS.rest';
import TSAnlaufstelleWithUsers from '../models/TSAnlaufstelleWithUsers';
import {ApplicationPropertyRS} from '../admin/service/applicationPropertyRS.rest';
import IPromise = angular.IPromise;
import IQService = angular.IQService;
import ILogService = angular.ILogService;

anlaufstelleverwaltungRun.$inject = ['RouterHelper'];

/* @ngInject */
export function anlaufstelleverwaltungRun(routerHelper: RouterHelper) {
    routerHelper.configureStates(getStates());
}

function getStates(): IState[] {
    return [
        new SerfAnlaufstelleVerwaltungState(),
        new SerfAnlaufstelleState(),
        new SerfAnlaufstelleRegistrierungState(),
    ];
}

export class SerfAnlaufstelleVerwaltungState implements IState {
    name = 'anlaufstelleverwaltung';
    template = '<dv-anlaufstelleverwaltung-view anlaufstellen="$resolve.anlaufstelleList" '
        + 'vereinbarung-missing="$resolve.vereinbarungMissingList" ></dv-anlaufstelleverwaltung-view>';
    url = '/anlaufstelleverwaltung/';
    resolve = {
        anlaufstelleList: loadAnlaufstellen,
        vereinbarungMissingList: loadMissingVereinbarungAnlaufstellen
    };
    params = {missingVereinbarungAnlaufstelle: null, bla: null};
}

export class SerfAnlaufstelleState implements IState {
    name = 'anlaufstelle';
    template = '<dv-anlaufstelle-view anlaufstelle="$resolve.anlaufstelle"></dv-anlaufstelle-view>';
    url = '/anlaufstelle/:anlaufstelleId';
    resolve = {
        anlaufstelle: getAnlaufstelle
    };
    params = {createNew: null, anlaufstelle: null, anlaufstelleId: null};
}

export class SerfAnlaufstelleRegistrierungState implements IState {
    name = 'anlaufstelleregistrierung';
    template = '<dv-anlaufstelle-registrierung-view  site-key="$resolve.siteKey"></dv-anlaufstelle-registrierung-view>';
    url = '/anlaufstelleregistrierung';
    resolve = {
        siteKey: loadSiteKey
    };
}

export class IAnlaufstelleStateParams implements IStateParamsService {
    createNew: boolean;
    anlaufstelleId: string;
    anlaufstelle: TSAnlaufstelle | undefined;
}

export class IAnlaufstelleVerwaltungParams implements IStateParamsService {
    missingVereinbarungAnlaufstelle: Array<TSAnlaufstelle>
}

loadSiteKey.$inject = ['ApplicationPropertyRS'];

export function loadSiteKey(ApplicationPropertyRS: ApplicationPropertyRS): IPromise<string> {
    return ApplicationPropertyRS.getRecaptchaSiteKey();
}

loadAnlaufstellen.$inject = ['AnlaufstelleRS', 'AuthServiceRS', 'BenutzerRS', 'RoleUtilService', '$q'];

export function loadAnlaufstellen(AnlaufstelleRS: AnlaufstelleRS, AuthServiceRS: AuthServiceRS, BenutzerRS: BenutzerRS,
                                  RoleUtilService: RoleUtilService, $q: IQService): IPromise<Array<TSAnlaufstelle>> {
    if (AuthServiceRS.isOneOfRoles(RoleUtilService.getAdministratorRoles())) {
        return AnlaufstelleRS.getAllAnlaufstellen();
    } else if (AuthServiceRS.isOneOfRoles(RoleUtilService.getAnlaufstelleVerwalterRoles())) {
        let principal = AuthServiceRS.getPrincipal();
        if (principal) {
            return BenutzerRS.getAnlaufstellenForBenutzer(principal.id);
        }
    }
    return $q.when([]);

}

loadMissingVereinbarungAnlaufstellen.$inject = ['$stateParams', '$q'];

export function loadMissingVereinbarungAnlaufstellen($stateParams: IAnlaufstelleVerwaltungParams,
                                                     $q: IQService): IPromise<Array<TSAnlaufstelle>> {
    if ($stateParams) {
        return $q.when<Array<TSAnlaufstelle>>($stateParams.missingVereinbarungAnlaufstelle);
    }
    return $q.when<Array<TSAnlaufstelle>>([]);

}

getAnlaufstelle.$inject = ['$stateParams', '$q', 'AnlaufstelleRS', '$log'];

let createAnlaufstelle = function () {
    let anlaufstelle: TSAnlaufstelleWithUsers = new TSAnlaufstelleWithUsers();
    anlaufstelle.adresse = new TSAdresse();
    anlaufstelle.verwalter = undefined;
    anlaufstelle.gemeinden = [];
    anlaufstelle.sachbearbeiter = [];
    anlaufstelle.schaetzer = [];
    return anlaufstelle;
};

export function getAnlaufstelle($stateParams: IAnlaufstelleStateParams, $q: IQService,
                                anlaufstelleRS: AnlaufstelleRS, log: ILogService): IPromise<TSAnlaufstelle> {
    if ($stateParams) {

        let anlaufstelleIdParam = $stateParams.anlaufstelleId;
        let passedAnlaufstelle = $stateParams.anlaufstelle;
        let createNew = $stateParams.createNew;
        if (createNew) {
            return $q.when(createAnlaufstelle());
        }
        // if (passedAnlaufstelle) {
        //     return $q.when(passedAnlaufstelle);
        // }
        if (anlaufstelleIdParam) {
            return anlaufstelleRS.findAnlaufstelleWithUsers(anlaufstelleIdParam).then((response: TSAnlaufstelle) => {
                if (response !== undefined && response.verwalter !== undefined) {
                    response.verwalter.passwordData = new TSPasswordData(response.verwalter.email);
                    return response;
                } else {
                    return this.$q.when(createAnlaufstelle());
                }
            });
        }
    }

    log.error('Can`t open requested anlaufstelle. Creating a new anlaufstelle object' + $stateParams);
    let deferred = $q.defer<TSAnlaufstelle>();
    deferred.resolve(createAnlaufstelle());
    return deferred.promise;
}








// WEBPACK FOOTER //
// ./src/app/anlaufstelleverwaltung/anlaufstelleverwaltung.route.ts